import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '@/pages/LoginPage';
import SignupPage from '@/pages/SignupPage';
import RequireAuth from '@/auth/RequireAuth';
import RequireTenant from '@/auth/RequireTenant';
import SelectTenantPage from '@/pages/SelectTenantPage';
import NoTenantsPage from '@/pages/NoTenantsPage';
import SignupTenantPage from '@/pages/SignupTenantPage';
import AcceptInvitationPage from '@/pages/AcceptInvitationPage';
import AppLayout from '@/layouts/AppLayout';
import OrganizationsPage from '@/pages/OrganizationsPage';
import ContractorsPage from '@/pages/ContractorsPage';
import NomenclaturePage from '@/pages/NomenclaturePage';
import ContractsRegistryPage from '@/pages/ContractsRegistryPage';
import NomenclatureKindsPage from '@/pages/refs/NomenclatureKindsPage';
import ContractCivilKindsPage from '@/pages/refs/ContractCivilKindsPage';
import ContractorGroupsPage from '@/pages/refs/ContractorGroupsPage';
import PriceTypesPage from '@/pages/refs/PriceTypesPage';
import AccountRulesPage from '@/pages/AccountRulesPage';
import PayrollAccountRulesPage from '@/pages/PayrollAccountRulesPage';
import AccrualTypesPage from '@/pages/refs/AccrualTypesPage';
import WorkSchedulesPage from '@/pages/refs/WorkSchedulesPage';
import StaffSchedulesPage from '@/pages/payroll/StaffSchedulesPage';
import StaffSchedulePrintPage from '@/pages/payroll/StaffSchedulePrintPage';
import PlannedAccrualOrdersPage from '@/pages/payroll/PlannedAccrualOrdersPage';
import PlannedAccrualOrderEditor from '@/pages/payroll/PlannedAccrualOrderEditor';
import PlannedAccrualOrderPrintPage from '@/pages/payroll/PlannedAccrualOrderPrintPage';
import ChartOfAccountsPage from '@/pages/ChartOfAccountsPage';
import AuditLogPage from '@/pages/AuditLogPage';
import HomePage from '@/pages/HomePage';
import ManualOperationsPage from '@/pages/ManualOperationsPage';
import ManualOperationEditor from '@/pages/ManualOperationEditor';
import GoodsReceiptsPage from '@/pages/GoodsReceiptsPage';
import GoodsReceiptEditor from '@/pages/GoodsReceiptEditor';
import GoodsSalesPage from '@/pages/GoodsSalesPage';
import GoodsSaleEditor from '@/pages/GoodsSaleEditor';
import GoodsSalePrintPage from '@/pages/GoodsSalePrintPage';
import CashOrderPrintPage from '@/pages/CashOrderPrintPage';
import GoodsTransfersPage from '@/pages/GoodsTransfersPage';
import GoodsTransferEditor from '@/pages/GoodsTransferEditor';
import InventoryCountsPage from '@/pages/InventoryCountsPage';
import InventoryCountEditor from '@/pages/InventoryCountEditor';
import OrdersPage from '@/pages/OrdersPage';
import OrderEditor from '@/pages/OrderEditor';
import AdvanceReportsPage from '@/pages/AdvanceReportsPage';
import AdvanceReportEditor from '@/pages/AdvanceReportEditor';
import AdvanceReportPrintPage from '@/pages/AdvanceReportPrintPage';
import DebtAdjustmentsPage from '@/pages/DebtAdjustmentsPage';
import DebtAdjustmentEditor from '@/pages/DebtAdjustmentEditor';
import DebtAdjustmentPrintPage from '@/pages/DebtAdjustmentPrintPage';
import DoubtfulDebtReservesPage from '@/pages/DoubtfulDebtReservesPage';
import DoubtfulDebtReserveEditor from '@/pages/DoubtfulDebtReserveEditor';
import GoodsRecognitionsPage from '@/pages/GoodsRecognitionsPage';
import GoodsRecognitionEditor from '@/pages/GoodsRecognitionEditor';
import GoodsWriteoffsPage from '@/pages/GoodsWriteoffsPage';
import GoodsWriteoffEditor from '@/pages/GoodsWriteoffEditor';
import CustomsDeclarationsPage from '@/pages/CustomsDeclarationsPage';
import CustomsDeclarationEditor from '@/pages/CustomsDeclarationEditor';
import CustomsDeclarationPrintPage from '@/pages/CustomsDeclarationPrintPage';
import AdditionalExpensesPage from '@/pages/AdditionalExpensesPage';
import AdditionalExpenseEditor from '@/pages/AdditionalExpenseEditor';
import AdditionalExpensePrintPage from '@/pages/AdditionalExpensePrintPage';
import ReconciliationActPage from '@/pages/ReconciliationActPage';
import ReconciliationActPrintPage from '@/pages/ReconciliationActPrintPage';
import OpeningBalancesPage from '@/pages/OpeningBalancesPage';
import OpeningBalanceEditor from '@/pages/OpeningBalanceEditor';
import ImportFromCsvPage from '@/pages/ImportFromCsvPage';
import PayrollsPage from '@/pages/PayrollsPage';
import AccrualsRegistryPage from '@/pages/AccrualsRegistryPage';
import EmployeeDebtsPage from '@/pages/payroll/EmployeeDebtsPage';
import PayrollEditor from '@/pages/PayrollEditor';
import TaxRemittancesPage from '@/pages/TaxRemittancesPage';
import FundReceiptsPage from '@/pages/FundReceiptsPage';
import FundReceiptEditor from '@/pages/FundReceiptEditor';
import TaxRemittanceEditor from '@/pages/TaxRemittanceEditor';
import PayrollPaymentsPage from '@/pages/PayrollPaymentsPage';
import PayrollPaymentEditor from '@/pages/PayrollPaymentEditor';
import PayrollPaymentPrintPage from '@/pages/PayrollPaymentPrintPage';
import PayrollPrintPage from '@/pages/PayrollPrintPage';
import TimesheetsPage from '@/pages/TimesheetsPage';
import TimesheetEditor from '@/pages/TimesheetEditor';
import DailyTimesheetEditor from '@/pages/DailyTimesheetEditor';
// Підпорція 1.5: legacy fixed-assets pages видалено. Replacement у pages/assets/.
import EmployeesPage from '@/pages/EmployeesPage';
import EmployeeEditor from '@/pages/EmployeeEditor';
import EmployeeWithDocumentPage from '@/pages/EmployeeWithDocumentPage';
import IndividualsPage from '@/pages/IndividualsPage';
import PositionsPage from '@/pages/PositionsPage';
import DepartmentsPage from '@/pages/DepartmentsPage';
import HireOrdersPage from '@/pages/HireOrdersPage';
import HrOrdersPage from '@/pages/HrOrdersPage';
import HireOrderEditor from '@/pages/HireOrderEditor';
import CivilLawContractEditor from '@/pages/CivilLawContractEditor';
import CivilLawContractsPage from '@/pages/CivilLawContractsPage';
import DpsCabinetPage from '@/pages/DpsCabinetPage';
import TaxReportJ05Editor from '@/pages/TaxReportJ05Editor';
import DpsRequestCreatePage from '@/pages/DpsRequestCreatePage';
import DpsCabinetNewPage from '@/pages/DpsCabinetNewPage';
import HireNotificationEditor from '@/pages/HireNotificationEditor';
import HireNotificationPrintPage from '@/pages/HireNotificationPrintPage';
import HireOrderPrintPage from '@/pages/HireOrderPrintPage';
import StaffTransfersPage from '@/pages/StaffTransfersPage';
import StaffTransferEditor from '@/pages/StaffTransferEditor';
import StaffTransferPrintPage from '@/pages/StaffTransferPrintPage';
import DismissalOrdersPage from '@/pages/DismissalOrdersPage';
import DismissalOrderEditor from '@/pages/DismissalOrderEditor';
import DismissalOrderPrintPage from '@/pages/DismissalOrderPrintPage';
import ProfessionClassifierPage from '@/pages/ProfessionClassifierPage';
import NumberSchemesPage from '@/pages/NumberSchemesPage';
import MigrationFromOneCPage from '@/pages/MigrationFromOneCPage';
import MigrationWizardPage from '@/pages/MigrationWizardPage';
import MigrationRunsListPage from '@/pages/MigrationRunsListPage';
import AdminPage from '@/pages/AdminPage';
import FinancialReportsPage from '@/pages/FinancialReportsPage';
import ProjectsPage from '@/pages/ProjectsPage';
import ProjectPLReportPage from '@/pages/ProjectPLReportPage';
import ProfitabilityReportPage from '@/pages/ProfitabilityReportPage';
import CashFlowReportPage from '@/pages/CashFlowReportPage';
import TaxReportsPage from '@/pages/TaxReportsPage';
import FxRevaluationsPage from '@/pages/FxRevaluationsPage';
import FxRevaluationEditor from '@/pages/FxRevaluationEditor';
import BankReceiptsPage from '@/pages/BankReceiptsPage';
import BankPaymentsPage from '@/pages/BankPaymentsPage';
import BankDocEditor from '@/pages/BankDocEditor';
import CashReceiptsPage from '@/pages/CashReceiptsPage';
import CashPaymentsPage from '@/pages/CashPaymentsPage';
import CashDocEditor from '@/pages/CashDocEditor';
import TrialBalancePage from '@/pages/TrialBalancePage';
import ProductionWipReportPage from '@/pages/ProductionWipReportPage';
import GoodsBalancePage from '@/pages/GoodsBalancePage';
import GoodsReservedPage from '@/pages/GoodsReservedPage';
import InventoryAnalyticsPage from '@/pages/InventoryAnalyticsPage';
import ServiceActsPage from '@/pages/ServiceActsPage';
import TarePage from '@/pages/TarePage';
import TareEditor from '@/pages/TareEditor';
import ServiceActEditor from '@/pages/ServiceActEditor';
import TnnPage from '@/pages/TnnPage';
import TnnEditor from '@/pages/TnnEditor';
import AccountCardPage from '@/pages/AccountCardPage';
import SubcontoAnalysisPage from '@/pages/SubcontoAnalysisPage';
import VatSummaryPage from '@/pages/VatSummaryPage';
import VatDeclarationPrintPage from '@/pages/VatDeclarationPrintPage';
import TaxInvoicesOutgoingPage from '@/pages/TaxInvoicesOutgoingPage';
import TaxInvoiceOutgoingViewer from '@/pages/TaxInvoiceOutgoingViewer';
import TaxInvoicesIncomingPage from '@/pages/TaxInvoicesIncomingPage';
import TaxInvoiceIncomingViewer from '@/pages/TaxInvoiceIncomingViewer';
import GoodsReturnsFromCustomerPage from '@/pages/GoodsReturnsFromCustomerPage';
import GoodsReturnFromCustomerViewer from '@/pages/GoodsReturnFromCustomerViewer';
import GoodsReturnsToSupplierPage from '@/pages/GoodsReturnsToSupplierPage';
import GoodsReturnToSupplierViewer from '@/pages/GoodsReturnToSupplierViewer';
import BankImportPage from '@/pages/BankImportPage';
import MonthClosingPage from '@/pages/MonthClosingPage';
// Виробничий блок (Порція Виробництво.4a, 2026-05-22) — 9 list-pages.
import NomenclatureSpecificationsPage from '@/pages/NomenclatureSpecificationsPage';
import ProductionReportsPage from '@/pages/ProductionReportsPage';
import ProductAssembliesPage from '@/pages/ProductAssembliesPage';
import ProductDisassembliesPage from '@/pages/ProductDisassembliesPage';
import MaterialTransfersForProcessingPage from '@/pages/MaterialTransfersForProcessingPage';
import MaterialRequisitionsPage from '@/pages/MaterialRequisitionsPage';
import MaterialReceiptsForProcessingPage from '@/pages/MaterialReceiptsForProcessingPage';
import ProcessingReceiptsPage from '@/pages/ProcessingReceiptsPage';
import ProcessingServicesSalesPage from '@/pages/ProcessingServicesSalesPage';
import ProductionServiceActsPage from '@/pages/ProductionServiceActsPage';
import WipInventoryPage from '@/pages/WipInventoryPage';
// Виробничий блок editors (Порція Виробництво.4b, 2026-05-22) — 9 editor pages.
import NomenclatureSpecificationEditor from '@/pages/NomenclatureSpecificationEditor';
import ProductionReportEditor from '@/pages/ProductionReportEditor';
import ProductAssemblyEditor from '@/pages/ProductAssemblyEditor';
import ProductDisassemblyEditor from '@/pages/ProductDisassemblyEditor';
import MaterialTransferForProcessingEditor from '@/pages/MaterialTransferForProcessingEditor';
import MaterialRequisitionEditor from '@/pages/MaterialRequisitionEditor';
import MaterialReceiptForProcessingEditor from '@/pages/MaterialReceiptForProcessingEditor';
import ProcessingReceiptEditor from '@/pages/ProcessingReceiptEditor';
import ProcessingServicesSalesEditor from '@/pages/ProcessingServicesSalesEditor';
import ProductionServiceActEditor from '@/pages/ProductionServiceActEditor';
import WipInventoryEditor from '@/pages/WipInventoryEditor';
// Роздрібний блок list-pages (Порція Роздріб.5a, 2026-05-23) — 15 list pages.
import PriceGroupsPage from '@/pages/retail/PriceGroupsPage';
import NomenclatureRetailPricesPage from '@/pages/retail/NomenclatureRetailPricesPage';
import PosWorkstationsPage from '@/pages/retail/PosWorkstationsPage';
import TradeEquipmentPage from '@/pages/retail/TradeEquipmentPage';
import TradeEquipmentEditor from '@/pages/retail/TradeEquipmentEditor';
import PaymentOrdersPage from '@/pages/banking/PaymentOrdersPage';
import PaymentOrderEditor from '@/pages/banking/PaymentOrderEditor';
import CurrencyOperationsPage from '@/pages/banking/CurrencyOperationsPage';
import CurrencyOperationEditor from '@/pages/banking/CurrencyOperationEditor';
import ReconciliationActsPage from '@/pages/settlements/ReconciliationActsPage';
import ReconciliationActEditor from '@/pages/settlements/ReconciliationActEditor';
import PowersOfAttorneyPage from '@/pages/settlements/PowersOfAttorneyPage';
import PowerOfAttorneyEditor from '@/pages/settlements/PowerOfAttorneyEditor';
import SettlementInventoriesPage from '@/pages/settlements/SettlementInventoriesPage';
import SettlementInventoryEditor from '@/pages/settlements/SettlementInventoryEditor';
import PosProvidersPage from '@/pages/retail/PosProvidersPage';
import CustomerCardsPage from '@/pages/retail/CustomerCardsPage';
import LoyaltySettingsPage from '@/pages/retail/LoyaltySettingsPage';
import SalesChannelsPage from '@/pages/retail/SalesChannelsPage';
import CustomerCardIssuesPage from '@/pages/retail/CustomerCardIssuesPage';
import CashShiftOpensPage from '@/pages/retail/CashShiftOpensPage';
import RetailSalesPage from '@/pages/retail/RetailSalesPage';
import LoyaltyTransactionsPage from '@/pages/retail/LoyaltyTransactionsPage';
import RetailReturnsPage from '@/pages/retail/RetailReturnsPage';
import CashShiftClosesPage from '@/pages/retail/CashShiftClosesPage';
import PriceChangesPage from '@/pages/retail/PriceChangesPage';
import OnlineStoreOrdersPage from '@/pages/retail/OnlineStoreOrdersPage';
// Роздрібний блок editor-pages (Порція Роздріб.5b, 2026-05-23) — 15 editors.
import PriceGroupEditor from '@/pages/retail/PriceGroupEditor';
import NomenclatureRetailPriceEditor from '@/pages/retail/NomenclatureRetailPriceEditor';
import PosWorkstationEditor from '@/pages/retail/PosWorkstationEditor';
import PosProviderEditor from '@/pages/retail/PosProviderEditor';
import CustomerCardEditor from '@/pages/retail/CustomerCardEditor';
import LoyaltySettingsEditor from '@/pages/retail/LoyaltySettingsEditor';
import SalesChannelEditor from '@/pages/retail/SalesChannelEditor';
import CustomerCardIssueEditor from '@/pages/retail/CustomerCardIssueEditor';
import CashShiftOpenEditor from '@/pages/retail/CashShiftOpenEditor';
import RetailSaleEditor from '@/pages/retail/RetailSaleEditor';
import LoyaltyTransactionEditor from '@/pages/retail/LoyaltyTransactionEditor';
import RetailReturnEditor from '@/pages/retail/RetailReturnEditor';
import CashShiftCloseEditor from '@/pages/retail/CashShiftCloseEditor';
import PriceChangeEditor from '@/pages/retail/PriceChangeEditor';
import OnlineStoreOrderEditor from '@/pages/retail/OnlineStoreOrderEditor';
import POSSetupWizard from '@/pages/retail/POSSetupWizard';
// Блок 9.2 (Warehouse Orders Workflow, 2026-05-24).
import WarehouseOrdersPage from '@/pages/warehouse/WarehouseOrdersPage';
import WarehouseOrderEditor from '@/pages/warehouse/WarehouseOrderEditor';
// Підпорція 3.1a (Блок 3 ПДВ): UKTZED + tax refs (2026-05-24).
import TaxPurposesPage from '@/pages/taxation/TaxPurposesPage';
import TaxPurposeRulesPage from '@/pages/taxation/TaxPurposeRulesPage';
import TaxationSchemesPage from '@/pages/taxation/TaxationSchemesPage';
import TaxOfficesPage from '@/pages/TaxOfficesPage';
// Підпорція 3.1b (Блок 3 ПДВ-коригування, 2026-05-24).
import TPInventoryPage from '@/pages/taxation/TPInventoryPage';
import TPTzrPage from '@/pages/taxation/TPTzrPage';
import EVCVAPage from '@/pages/taxation/EVCVAPage';
// Підпорція 3.1c (Блок 3 ПДВ-документи, 2026-05-24).
import {
  AdvancePaymentsPage,
  Appendix1Page,
  Appendix2Page,
  PropRecalcPage,
  PropCoefPage,
} from '@/pages/taxation/VatDocumentsPages';
// Підпорція 3.2a (Блок 3 податок на прибуток, 2026-05-25).
import {
  IncomeTaxNormalizationsPage,
  IncomeTaxCalculationsPage,
} from '@/pages/taxation/IncomeTaxPages';
// Підпорція 3.2b (customs + tax_declaration_articles, 2026-05-25).
import { TaxDeclarationArticlesPage } from '@/pages/taxation/TaxDeclarationArticlesPage';
import { CustomsNumbersRegisterPage } from '@/pages/taxation/CustomsNumbersRegisterPage';
// Підпорція 1.1 (Block 1: assets foundation, 2026-05-25).
import {
  AssetGroupsPage,
  DepreciationMethodsPage,
  FixedAssetsPage as FixedAssetsV2Page,
  IntangibleAssetsPage as IntangibleAssetsV2Page,
  LowValueAssetsPage,
  AssetCommissioningPage,
  AssetWriteOffPage,
} from '@/pages/assets/AssetsPages';
// Підпорція 1.2 (depreciation).
import { DepreciationCalculationPage } from '@/pages/assets/DepreciationPage';
// Підпорція 1.3 (modernization + internal transfer).
import {
  ModernizationPage,
  InternalTransferPage,
} from '@/pages/assets/MovementPages';
// Підпорція 1.4 (inventory + sale).
import {
  InventoryPage,
  SalePage,
} from '@/pages/assets/InventorySalePages';
// Block 7 (commission).
import {
  CommissionContractsPage,
  CommissionTransferPage,
  CommissionSalePage,
  CommissionSettlementPage,
} from '@/pages/commission/CommissionPages';
// Block 2.0+2.1 (production calendar + vacation).
import {
  ProductionCalendarPage,
  VacationOrdersPage,
  VacationCalculationsPage,
} from '@/pages/vacation/VacationPages';
import VacationOrderEditor from '@/pages/vacation/VacationOrderEditor';
import VacationOrderPrintPage from '@/pages/vacation/VacationOrderPrintPage';
import VacationCalculationCreatePage from '@/pages/vacation/VacationCalculationCreatePage';
import VacationCalculationEditor from '@/pages/vacation/VacationCalculationEditor';
import VacationCompensationsPage from '@/pages/vacation/VacationCompensationsPage';
import VacationCompensationEditor from '@/pages/vacation/VacationCompensationEditor';
import VacationCompensationCreatePage from '@/pages/vacation/VacationCompensationCreatePage';
// Block 2.2 (sick leave).
import {
  SickLeavesPage,
  SickLeaveCalculationsPage,
} from '@/pages/sick_leave/SickLeavePages';
import SickLeaveEditor from '@/pages/sick_leave/SickLeaveEditor';
// Block 5.1 (month-close runner).
import { MonthCloseRunsPage } from '@/pages/month_close/MonthCloseRunsPage';
// Block 6 (accounting constants).
import { AccountingConstantsPage } from '@/pages/refs/AccountingConstantsPage';
// Block 8.2 / 8.3 (ФОП).
import {
  SingleTaxCalculationsPage,
  FopSelfEsvPaymentsPage,
  FopSelfWzPaymentsPage,
} from '@/pages/fop/FopPages';
import { FopReportsPage } from '@/pages/fop/FopReportsPage';
import FopZsoQuarterlyCalculationsPage from '@/pages/fop/FopZsoQuarterlyCalculationsPage';
// POS UI (Порція Роздріб.6, 2026-05-23) — окремий kiosk-mode без AppLayout.
import POSScreen from '@/pages/pos/POSScreen';
import POSGuard from '@/pages/pos/POSGuard';
import POSReceiptPrint from '@/pages/pos/POSReceiptPrint';
// Platform Admin Блок A (super-admin, 2FA) — окрема гілка роутингу без AppLayout.
import PlatformLayout from '@/layouts/PlatformLayout';
import PlatformSystemDataPage from '@/pages/platform/PlatformSystemDataPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      {/* Публічна accept-сторінка — без RequireAuth, бо до accept'а user
          ще не залогінений (новий user) або залогінений іншим email. */}
      <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
      {/* Tenant flow (Порція 3.0.5.1b): автентифікація потрібна, але
          tenant ще не виставлений. */}
      <Route
        path="/select-tenant"
        element={
          <RequireAuth>
            <SelectTenantPage />
          </RequireAuth>
        }
      />
      <Route
        path="/no-tenants"
        element={
          <RequireAuth>
            <NoTenantsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/signup-tenant"
        element={
          <RequireAuth>
            <SignupTenantPage />
          </RequireAuth>
        }
      />
      <Route
        path="/"
        element={
          <RequireAuth>
            <RequireTenant>
              <AppLayout />
            </RequireTenant>
          </RequireAuth>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="organizations" element={<OrganizationsPage />} />
        <Route path="contractors" element={<ContractorsPage />} />
        <Route path="contracts-registry" element={<ContractsRegistryPage />} />
        <Route path="nomenclature" element={<NomenclaturePage />} />
        <Route path="refs/nomenclature-kinds" element={<NomenclatureKindsPage />} />
        <Route path="refs/contract-civil-kinds" element={<ContractCivilKindsPage />} />
        <Route path="refs/contractor-groups" element={<ContractorGroupsPage />} />
        <Route path="refs/price-types" element={<PriceTypesPage />} />
        <Route path="refs/account-rules" element={<AccountRulesPage />} />
        <Route path="refs/payroll-account-rules" element={<PayrollAccountRulesPage />} />
        <Route path="refs/accrual-types" element={<AccrualTypesPage />} />
        <Route path="refs/work-schedules" element={<WorkSchedulesPage />} />
        <Route path="staff-schedule" element={<StaffSchedulesPage />} />
        <Route path="staff-schedule/print" element={<StaffSchedulePrintPage />} />
        <Route path="payroll/planned-accrual-orders" element={<PlannedAccrualOrdersPage />} />
        <Route path="payroll/planned-accrual-orders/new" element={<PlannedAccrualOrderEditor />} />
        <Route path="payroll/planned-accrual-orders/:id/print" element={<PlannedAccrualOrderPrintPage />} />
        <Route path="payroll/planned-accrual-orders/:id" element={<PlannedAccrualOrderEditor />} />
        <Route path="chart-of-accounts" element={<ChartOfAccountsPage />} />
        <Route path="audit-log" element={<AuditLogPage />} />
        <Route path="manual-operations" element={<ManualOperationsPage />} />
        <Route path="manual-operations/:id" element={<ManualOperationEditor />} />
        <Route path="goods-receipts" element={<GoodsReceiptsPage />} />
        <Route path="goods-receipts/:id" element={<GoodsReceiptEditor />} />
        <Route path="goods-sales" element={<GoodsSalesPage />} />
        <Route path="goods-sales/:id" element={<GoodsSaleEditor />} />
        <Route path="goods-sales/:id/print" element={<GoodsSalePrintPage />} />
        <Route path="service-acts" element={<ServiceActsPage />} />
        <Route path="service-acts/:id" element={<ServiceActEditor />} />
        <Route path="tnn" element={<TnnPage />} />
        <Route path="tnn/:id" element={<TnnEditor />} />
        <Route path="goods-transfers" element={<GoodsTransfersPage />} />
        <Route path="goods-transfers/:id" element={<GoodsTransferEditor />} />
        <Route path="tare-transfers" element={<TarePage kind="transfer" />} />
        <Route path="tare-transfers/:id" element={<TareEditor kind="transfer" />} />
        <Route path="tare-returns" element={<TarePage kind="return" />} />
        <Route path="tare-returns/:id" element={<TareEditor kind="return" />} />
        <Route path="inventory-counts" element={<InventoryCountsPage />} />
        <Route path="inventory-counts/:id" element={<InventoryCountEditor />} />
        <Route path="customer-orders" element={<OrdersPage kind="customer" forcedOrderKind="ORDER" title="Замовлення покупців" newButtonLabel="Нове замовлення" />} />
        <Route path="customer-orders/:id" element={<OrderEditor kind="customer" />} />
        <Route path="customer-invoices" element={<OrdersPage kind="customer" forcedOrderKind="PROFORMA_INVOICE" title="Рахунки покупцям" newButtonLabel="Новий рахунок" />} />
        <Route path="customer-invoices/:id" element={<OrderEditor kind="customer" />} />
        <Route path="supplier-orders" element={<OrdersPage kind="supplier" forcedOrderKind="ORDER" title="Замовлення постачальникам" newButtonLabel="Нове замовлення" />} />
        <Route path="supplier-orders/:id" element={<OrderEditor kind="supplier" />} />
        <Route path="supplier-invoices" element={<OrdersPage kind="supplier" forcedOrderKind="PROFORMA_INVOICE" title="Рахунки від постачальників" newButtonLabel="Новий рахунок" />} />
        <Route path="supplier-invoices/:id" element={<OrderEditor kind="supplier" />} />
        <Route path="advance-reports" element={<AdvanceReportsPage />} />
        <Route path="advance-reports/:id" element={<AdvanceReportEditor />} />
        <Route path="advance-reports/:id/print" element={<AdvanceReportPrintPage />} />
        <Route path="debt-adjustments" element={<DebtAdjustmentsPage />} />
        <Route path="debt-adjustments/:id" element={<DebtAdjustmentEditor />} />
        <Route path="debt-adjustments/:id/print" element={<DebtAdjustmentPrintPage />} />
        <Route path="doubtful-debt-reserves" element={<DoubtfulDebtReservesPage />} />
        <Route path="doubtful-debt-reserves/:id" element={<DoubtfulDebtReserveEditor />} />
        <Route path="goods-recognitions" element={<GoodsRecognitionsPage />} />
        <Route path="goods-recognitions/:id" element={<GoodsRecognitionEditor />} />
        <Route path="goods-writeoffs" element={<GoodsWriteoffsPage />} />
        <Route path="goods-writeoffs/:id" element={<GoodsWriteoffEditor />} />
        <Route path="customs-declarations" element={<CustomsDeclarationsPage />} />
        <Route path="customs-declarations/:id" element={<CustomsDeclarationEditor />} />
        <Route path="customs-declarations/:id/print" element={<CustomsDeclarationPrintPage />} />
        <Route path="additional-expenses" element={<AdditionalExpensesPage />} />
        <Route path="additional-expenses/:id" element={<AdditionalExpenseEditor />} />
        <Route path="additional-expenses/:id/print" element={<AdditionalExpensePrintPage />} />
        <Route path="fx-revaluations" element={<FxRevaluationsPage />} />
        <Route path="fx-revaluations/:id" element={<FxRevaluationEditor />} />
        <Route path="bank-receipts" element={<BankReceiptsPage />} />
        <Route path="bank-receipts/:id" element={<BankDocEditor kind="receipt" />} />
        <Route path="bank-payments" element={<BankPaymentsPage />} />
        <Route path="bank-payments/:id" element={<BankDocEditor kind="payment" />} />
        <Route path="cash-receipts" element={<CashReceiptsPage />} />
        <Route path="cash-receipts/:id" element={<CashDocEditor kind="receipt" />} />
        <Route path="cash-receipts/:id/print" element={<CashOrderPrintPage kind="receipt" />} />
        <Route path="cash-payments" element={<CashPaymentsPage />} />
        <Route path="cash-payments/:id" element={<CashDocEditor kind="payment" />} />
        <Route path="cash-payments/:id/print" element={<CashOrderPrintPage kind="payment" />} />
        <Route path="tax-invoices-outgoing" element={<TaxInvoicesOutgoingPage />} />
        <Route path="tax-invoices-outgoing/:id" element={<TaxInvoiceOutgoingViewer />} />
        <Route path="tax-invoices-incoming" element={<TaxInvoicesIncomingPage />} />
        <Route path="tax-invoices-incoming/:id" element={<TaxInvoiceIncomingViewer />} />
        <Route path="goods-returns-from-customer" element={<GoodsReturnsFromCustomerPage />} />
        <Route path="goods-returns-from-customer/:id" element={<GoodsReturnFromCustomerViewer />} />
        <Route path="goods-returns-to-supplier" element={<GoodsReturnsToSupplierPage />} />
        <Route path="goods-returns-to-supplier/:id" element={<GoodsReturnToSupplierViewer />} />
        {/* Виробничий блок list-pages (Порція 4a) + editors (Порція 4b). */}
        <Route path="nomenclature-specifications" element={<NomenclatureSpecificationsPage />} />
        <Route path="nomenclature-specifications/:id" element={<NomenclatureSpecificationEditor />} />
        <Route path="production-reports" element={<ProductionReportsPage />} />
        <Route path="production-reports/:id" element={<ProductionReportEditor />} />
        <Route path="product-assemblies" element={<ProductAssembliesPage />} />
        <Route path="product-assemblies/:id" element={<ProductAssemblyEditor />} />
        <Route path="product-disassemblies" element={<ProductDisassembliesPage />} />
        <Route path="product-disassemblies/:id" element={<ProductDisassemblyEditor />} />
        <Route path="material-transfers-for-processing" element={<MaterialTransfersForProcessingPage />} />
        <Route path="material-transfers-for-processing/:id" element={<MaterialTransferForProcessingEditor />} />
        <Route path="material-requisitions" element={<MaterialRequisitionsPage />} />
        <Route path="material-requisitions/:id" element={<MaterialRequisitionEditor />} />
        <Route path="material-receipts-for-processing" element={<MaterialReceiptsForProcessingPage />} />
        <Route path="material-receipts-for-processing/:id" element={<MaterialReceiptForProcessingEditor />} />
        <Route path="processing-receipts" element={<ProcessingReceiptsPage />} />
        <Route path="processing-receipts/:id" element={<ProcessingReceiptEditor />} />
        <Route path="processing-services-sales" element={<ProcessingServicesSalesPage />} />
        <Route path="processing-services-sales/:id" element={<ProcessingServicesSalesEditor />} />
        <Route path="production-service-acts" element={<ProductionServiceActsPage />} />
        <Route path="production-service-acts/:id" element={<ProductionServiceActEditor />} />
        <Route path="wip-inventory" element={<WipInventoryPage />} />
        <Route path="wip-inventory/:id" element={<WipInventoryEditor />} />
        <Route path="reports/trial-balance" element={<TrialBalancePage />} />
        <Route path="reports/production-wip" element={<ProductionWipReportPage />} />
        <Route path="reports/goods-balance" element={<GoodsBalancePage />} />
        <Route path="reports/goods-reserved" element={<GoodsReservedPage />} />
        <Route path="reports/inventory-analytics" element={<InventoryAnalyticsPage />} />
        <Route path="reports/account-card" element={<AccountCardPage />} />
        <Route path="reports/subconto-analysis" element={<SubcontoAnalysisPage />} />
        <Route path="reports/reconciliation-act" element={<ReconciliationActPage />} />
        <Route path="reports/reconciliation-act/print" element={<ReconciliationActPrintPage />} />
        <Route path="opening-balances" element={<OpeningBalancesPage />} />
        <Route path="opening-balances/:id" element={<OpeningBalanceEditor />} />
        <Route path="import-csv" element={<ImportFromCsvPage />} />
        <Route path="payrolls" element={<AccrualsRegistryPage />} />
        <Route path="payrolls/legacy" element={<PayrollsPage />} />
        <Route path="payroll-debts" element={<EmployeeDebtsPage />} />
        {/* legacy-аліас (стара адреса «вид нарахування борги») */}
        <Route path="payrolls/debts" element={<EmployeeDebtsPage />} />
        <Route path="payrolls/:id" element={<PayrollEditor />} />
        <Route path="payroll-payments" element={<PayrollPaymentsPage />} />
        <Route path="payroll-payments/:id" element={<PayrollPaymentEditor />} />
        <Route path="payroll-payments/:id/print" element={<PayrollPaymentPrintPage />} />
        <Route path="tax-remittances" element={<TaxRemittancesPage />} />
        <Route path="fund-receipts" element={<FundReceiptsPage />} />
        <Route path="fund-receipts/:id" element={<FundReceiptEditor />} />
        <Route path="tax-remittances/:id" element={<TaxRemittanceEditor />} />
        <Route path="payrolls/:id/print" element={<PayrollPrintPage />} />
        <Route path="timesheets" element={<TimesheetsPage />} />
        <Route path="timesheets/:id" element={<TimesheetEditor />} />
        <Route path="daily-timesheets/:id" element={<DailyTimesheetEditor />} />
        {/* Підпорція 1.5: legacy /fixed-assets, /fa-* routes видалено. */}
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="employees/new-unified" element={<EmployeeWithDocumentPage />} />
        <Route path="employees/:id" element={<EmployeeEditor />} />
        <Route path="individuals" element={<IndividualsPage />} />
        <Route path="positions" element={<PositionsPage />} />
        <Route path="profession-classifier" element={<ProfessionClassifierPage />} />
        <Route path="settings/number-schemes" element={<NumberSchemesPage />} />
        <Route path="admin" element={<AdminPage />} />
        {/* /team об'єднано у /admin?tab=users (Порція Виробництво.5 UX). */}
        <Route path="team" element={<Navigate to="/admin?tab=users" replace />} />
        <Route path="migration/from-1c" element={<MigrationFromOneCPage />} />
        <Route path="migration/wizard" element={<MigrationWizardPage />} />
        <Route path="migration/runs" element={<MigrationRunsListPage />} />
        <Route path="reports/financial" element={<FinancialReportsPage />} />
        <Route path="reports/tax" element={<TaxReportsPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="reports/project-pnl" element={<ProjectPLReportPage />} />
        <Route path="reports/profitability" element={<ProfitabilityReportPage />} />
        <Route path="reports/cash-flow" element={<CashFlowReportPage />} />
        <Route path="departments" element={<DepartmentsPage />} />
        <Route path="hr-orders" element={<HrOrdersPage />} />
        <Route path="hire-orders" element={<HireOrdersPage />} />
        <Route path="hire-orders/:id" element={<HireOrderEditor />} />
        <Route path="hire-orders/:id/print" element={<HireOrderPrintPage />} />
        <Route path="civil-law-contracts" element={<CivilLawContractsPage />} />
        <Route path="civil-law-contracts/:id" element={<CivilLawContractEditor />} />
        <Route path="dps-cabinet" element={<DpsCabinetPage />} />
        <Route path="dps-cabinet/new" element={<DpsCabinetNewPage />} />
        <Route path="dps-cabinet/requests/new" element={<DpsRequestCreatePage />} />
        <Route path="dps-cabinet/requests/:id" element={<DpsRequestCreatePage />} />
        <Route path="tax-reports-j05/new" element={<TaxReportJ05Editor />} />
        <Route path="tax-reports-j05/:id" element={<TaxReportJ05Editor />} />
        <Route path="hire-notifications/:id" element={<HireNotificationEditor />} />
        <Route path="hire-notifications/:id/print" element={<HireNotificationPrintPage />} />
        <Route path="staff-transfers" element={<StaffTransfersPage />} />
        <Route path="staff-transfers/:id" element={<StaffTransferEditor />} />
        <Route path="staff-transfers/:id/print" element={<StaffTransferPrintPage />} />
        <Route path="dismissal-orders" element={<DismissalOrdersPage />} />
        <Route path="dismissal-orders/:id" element={<DismissalOrderEditor />} />
        <Route path="dismissal-orders/:id/print" element={<DismissalOrderPrintPage />} />
        <Route path="reports/vat-summary" element={<VatSummaryPage />} />
        <Route path="reports/vat-declaration-print" element={<VatDeclarationPrintPage />} />
        <Route path="bank-import" element={<BankImportPage />} />
        <Route path="closing/month" element={<MonthClosingPage />} />
        {/* Роздрібний блок list-pages (Порція Роздріб.5a). Editor-pages — Порція 5b. */}
        <Route path="retail/price-groups" element={<PriceGroupsPage />} />
        <Route path="retail/price-groups/:id" element={<PriceGroupEditor />} />
        <Route path="retail/nomenclature-retail-prices" element={<NomenclatureRetailPricesPage />} />
        <Route path="retail/nomenclature-retail-prices/:id" element={<NomenclatureRetailPriceEditor />} />
        <Route path="retail/pos-workstations" element={<PosWorkstationsPage />} />
        <Route path="retail/pos-workstations/:id" element={<PosWorkstationEditor />} />
        <Route path="retail/trade-equipment" element={<TradeEquipmentPage />} />
        <Route path="retail/trade-equipment/:id" element={<TradeEquipmentEditor />} />
        <Route path="warehouse/orders" element={<WarehouseOrdersPage />} />
        <Route path="warehouse/orders/:id" element={<WarehouseOrderEditor />} />
        <Route path="refs/tax-purposes" element={<TaxPurposesPage />} />
        <Route path="refs/tax-purpose-rules" element={<TaxPurposeRulesPage />} />
        <Route path="refs/taxation-schemes" element={<TaxationSchemesPage />} />
        <Route path="refs/tax-offices" element={<TaxOfficesPage />} />
        <Route path="taxation/tax-purpose-adj-inventory" element={<TPInventoryPage />} />
        <Route path="taxation/tax-purpose-adj-tzr" element={<TPTzrPage />} />
        <Route path="taxation/expected-confirmed-vat-adj" element={<EVCVAPage />} />
        <Route path="taxation/advance-payment-registrations" element={<AdvancePaymentsPage />} />
        <Route path="taxation/tax-invoice-appendix-1" element={<Appendix1Page />} />
        <Route path="taxation/tax-invoice-appendix-2" element={<Appendix2Page />} />
        <Route path="taxation/proportional-vat-recalculation" element={<PropRecalcPage />} />
        <Route path="taxation/proportional-vat-coefficient" element={<PropCoefPage />} />
        <Route path="taxation/income-tax/normalizations" element={<IncomeTaxNormalizationsPage />} />
        <Route path="taxation/income-tax/calculations" element={<IncomeTaxCalculationsPage />} />
        <Route path="taxation/tax-declaration-articles" element={<TaxDeclarationArticlesPage />} />
        <Route path="taxation/customs-numbers-register" element={<CustomsNumbersRegisterPage />} />
        <Route path="assets/groups" element={<AssetGroupsPage />} />
        <Route path="assets/depreciation-methods" element={<DepreciationMethodsPage />} />
        <Route path="assets/fixed" element={<FixedAssetsV2Page />} />
        <Route path="assets/intangible" element={<IntangibleAssetsV2Page />} />
        <Route path="assets/low-value" element={<LowValueAssetsPage />} />
        <Route path="assets/commissioning" element={<AssetCommissioningPage />} />
        <Route path="assets/write-off" element={<AssetWriteOffPage />} />
        <Route path="assets/depreciation" element={<DepreciationCalculationPage />} />
        <Route path="assets/modernization" element={<ModernizationPage />} />
        <Route path="assets/transfer" element={<InternalTransferPage />} />
        <Route path="assets/inventory" element={<InventoryPage />} />
        <Route path="assets/sale" element={<SalePage />} />
        <Route path="commission/contracts" element={<CommissionContractsPage />} />
        <Route path="commission/transfer" element={<CommissionTransferPage />} />
        <Route path="commission/sale" element={<CommissionSalePage />} />
        <Route path="commission/settlement" element={<CommissionSettlementPage />} />
        <Route path="refs/production-calendar" element={<ProductionCalendarPage />} />
        <Route path="hr/vacation-orders" element={<VacationOrdersPage />} />
        <Route path="hr/vacation-orders/new" element={<VacationOrderEditor />} />
        <Route path="hr/vacation-orders/:id" element={<VacationOrderEditor />} />
        <Route path="hr/vacation-orders/:id/print" element={<VacationOrderPrintPage />} />
        <Route path="hr/vacation-compensations" element={<VacationCompensationsPage />} />
        <Route path="hr/vacation-compensations/new" element={<VacationCompensationCreatePage />} />
        <Route path="hr/vacation-compensations/:id" element={<VacationCompensationEditor />} />
        <Route path="hr/vacation-calculations" element={<VacationCalculationsPage />} />
        <Route path="hr/vacation-calculations/new" element={<VacationCalculationCreatePage />} />
        <Route path="hr/vacation-calculations/:id" element={<VacationCalculationEditor />} />
        <Route path="hr/sick-leaves" element={<SickLeavesPage />} />
        <Route path="hr/sick-leaves/:id" element={<SickLeaveEditor />} />
        <Route path="hr/sick-leave-calculations" element={<SickLeaveCalculationsPage />} />
        <Route path="period-close/runs" element={<MonthCloseRunsPage />} />
        <Route path="refs/accounting-constants" element={<AccountingConstantsPage />} />
        <Route path="fop/single-tax" element={<SingleTaxCalculationsPage />} />
        <Route path="fop/self-esv" element={<FopSelfEsvPaymentsPage />} />
        <Route path="fop/self-wz" element={<FopSelfWzPaymentsPage />} />
        <Route path="fop/reports" element={<FopReportsPage />} />
        <Route path="fop-zso/quarterly" element={<FopZsoQuarterlyCalculationsPage />} />
        <Route path="banking/payment-orders" element={<PaymentOrdersPage />} />
        <Route path="banking/payment-orders/:id" element={<PaymentOrderEditor />} />
        <Route path="banking/currency-operations" element={<CurrencyOperationsPage />} />
        <Route path="banking/currency-operations/:id" element={<CurrencyOperationEditor />} />
        <Route path="settlements/reconciliation-acts" element={<ReconciliationActsPage />} />
        <Route path="settlements/reconciliation-acts/:id" element={<ReconciliationActEditor />} />
        <Route path="settlements/powers-of-attorney" element={<PowersOfAttorneyPage />} />
        <Route path="settlements/powers-of-attorney/:id" element={<PowerOfAttorneyEditor />} />
        <Route path="settlements/settlement-inventories" element={<SettlementInventoriesPage />} />
        <Route path="settlements/settlement-inventories/:id" element={<SettlementInventoryEditor />} />
        <Route path="retail/pos-providers" element={<PosProvidersPage />} />
        <Route path="retail/pos-providers/:id" element={<PosProviderEditor />} />
        <Route path="retail/customer-cards" element={<CustomerCardsPage />} />
        <Route path="retail/customer-cards/:id" element={<CustomerCardEditor />} />
        <Route path="retail/loyalty-settings" element={<LoyaltySettingsPage />} />
        <Route path="retail/loyalty-settings/:id" element={<LoyaltySettingsEditor />} />
        <Route path="retail/sales-channels" element={<SalesChannelsPage />} />
        <Route path="retail/sales-channels/:id" element={<SalesChannelEditor />} />
        <Route path="retail/customer-card-issue" element={<CustomerCardIssuesPage />} />
        <Route path="retail/customer-card-issue/:id" element={<CustomerCardIssueEditor />} />
        <Route path="retail/cash-shift-open" element={<CashShiftOpensPage />} />
        <Route path="retail/cash-shift-open/:id" element={<CashShiftOpenEditor />} />
        <Route path="retail/retail-sales" element={<RetailSalesPage />} />
        <Route path="retail/retail-sales/:id" element={<RetailSaleEditor />} />
        <Route path="retail/loyalty-transactions" element={<LoyaltyTransactionsPage />} />
        <Route path="retail/loyalty-transactions/:id" element={<LoyaltyTransactionEditor />} />
        <Route path="retail/retail-returns" element={<RetailReturnsPage />} />
        <Route path="retail/retail-returns/:id" element={<RetailReturnEditor />} />
        <Route path="retail/cash-shift-close" element={<CashShiftClosesPage />} />
        <Route path="retail/cash-shift-close/:id" element={<CashShiftCloseEditor />} />
        <Route path="retail/price-changes" element={<PriceChangesPage />} />
        <Route path="retail/price-changes/:id" element={<PriceChangeEditor />} />
        <Route path="retail/online-store-orders" element={<OnlineStoreOrdersPage />} />
        <Route path="retail/online-store-orders/:id" element={<OnlineStoreOrderEditor />} />
        <Route path="retail/setup-wizard" element={<POSSetupWizard />} />
      </Route>
      {/* POS UI (Порція Роздріб.6) — kiosk-mode БЕЗ AppLayout/sidebar.
          Окремий шлях з власним POSGuard (перевіряє retail.sale.create). */}
      <Route
        path="/pos"
        element={
          <RequireAuth>
            <RequireTenant>
              <POSGuard>
                <POSScreen />
              </POSGuard>
            </RequireTenant>
          </RequireAuth>
        }
      />
      <Route
        path="/pos/receipt/:id/print"
        element={
          <RequireAuth>
            <RequireTenant>
              <POSGuard>
                <POSReceiptPrint />
              </POSGuard>
            </RequireTenant>
          </RequireAuth>
        }
      />
      {/* Platform Admin Блок A (super-admin) — окрема гілка БЕЗ AppLayout/
          RequireTenant. Гейт по платформенному статусу — у PlatformLayout
          (GET /auth/platform-status; не власник → redirect на /). */}
      <Route
        path="/platform"
        element={
          <RequireAuth>
            <PlatformLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/platform/system-data" replace />} />
        <Route path="system-data" element={<PlatformSystemDataPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
